const OPEN_MODAL_SELECTOR = [
  '[role="dialog"]',
  '[role="alertdialog"]',
  '.modal.show',
  '.modal.d-block',
  '.offcanvas.show',
].join(',');

const LOCK_CLASS = 'app-modal-scroll-locked';

function isVisible(element: Element) {
  if (!(element instanceof HTMLElement) || element.getAttribute('aria-hidden') === 'true') return false;
  const styles = window.getComputedStyle(element);
  return styles.display !== 'none'
    && styles.visibility !== 'hidden'
    && element.getClientRects().length > 0;
}

export function installModalScrollLock() {
  let locked = false;
  let scrollPosition = 0;
  let animationFrame = 0;

  const lock = () => {
    if (locked) return;
    locked = true;
    scrollPosition = window.scrollY;
    const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);

    document.documentElement.style.setProperty('--app-modal-scroll-position', `${-scrollPosition}px`);
    document.documentElement.style.setProperty('--app-modal-scrollbar-width', `${scrollbarWidth}px`);
    document.documentElement.classList.add(LOCK_CLASS);
    document.body.classList.add(LOCK_CLASS);
  };

  const unlock = () => {
    if (!locked) return;
    locked = false;
    document.body.classList.remove(LOCK_CLASS);
    window.scrollTo(0, scrollPosition);
    document.documentElement.classList.remove(LOCK_CLASS);
    document.documentElement.style.removeProperty('--app-modal-scroll-position');
    document.documentElement.style.removeProperty('--app-modal-scrollbar-width');
  };

  const sync = () => {
    animationFrame = 0;
    const hasOpenModal = Array.from(document.querySelectorAll(OPEN_MODAL_SELECTOR)).some(isVisible);
    if (hasOpenModal) lock();
    else unlock();
  };

  const scheduleSync = () => {
    if (animationFrame) cancelAnimationFrame(animationFrame);
    animationFrame = requestAnimationFrame(sync);
  };

  const observer = new MutationObserver(scheduleSync);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'aria-hidden', 'aria-modal'],
  });

  document.addEventListener('shown.bs.modal', scheduleSync);
  document.addEventListener('hidden.bs.modal', scheduleSync);
  scheduleSync();

  return () => {
    observer.disconnect();
    document.removeEventListener('shown.bs.modal', scheduleSync);
    document.removeEventListener('hidden.bs.modal', scheduleSync);
    if (animationFrame) cancelAnimationFrame(animationFrame);
    unlock();
  };
}
